import { render, staticRenderFns } from "./customDashboardLogins.vue?vue&type=template&id=92491cc0&scoped=true"
import script from "./customDashboardLogins.vue?vue&type=script&lang=js"
export * from "./customDashboardLogins.vue?vue&type=script&lang=js"
import style0 from "./customDashboardLogins.vue?vue&type=style&index=0&id=92491cc0&prod&lang=scss"
import style1 from "./customDashboardLogins.vue?vue&type=style&index=1&id=92491cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92491cc0",
  null
  
)

export default component.exports